import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { isLoggedIn } from '../../utils/jwt.utils';
import { AuthHttpService } from '../api/auth-http.service';
import { deleteSession } from '../storage.service';

@Injectable()
export class RefreshTokenService {
  isRefreshing = new BehaviorSubject<boolean>(false);

  constructor(
    private authHttpService: AuthHttpService,
    private router: Router
  ) {
    this.isRefreshing.distinctUntilChanged().subscribe(
      (refreshing: boolean) => {
        if (refreshing) {
          this.refreshToken();
        }
      }
    );
  }

  checkRefreshToken() {
    if (!isLoggedIn()) {
      this.isRefreshing.next(true);
    }
  }

  refreshToken() {
    this.authHttpService.refreshToken()
      .subscribe(this.refreshSuccess, this.refreshError);
  }

  private refreshSuccess = () => {
    this.isRefreshing.next(false);
  }

  private refreshError = (error: Response) => {
    if (error.status === 401 || error.status === 403) {
      if (error.status === 401) {
        deleteSession();
      }
      this.router.navigate(['/login']);
    }
    this.isRefreshing.next(false);
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/authentication/refresh-token.service.ts